/** Word's error as one line: code, message and where it happened. */
export const describeError = (error: unknown): string => {
  const e = error as { code?: string; message?: string; debugInfo?: { errorLocation?: string; errorMessage?: string } };
  return (
    [
      e?.code,
      e?.debugInfo?.errorMessage || e?.message,
      e?.debugInfo?.errorLocation && `at ${e.debugInfo.errorLocation}`,
    ]
      .filter(Boolean)
      .join(" ")
      .trim() || String(error)
  );
};
